import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { BONUS_TOTAL, OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-gris" data-id="element-53" data-mp="c7adc3u6m4g0">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-4 sm:py-8" data-id="element-54" data-mp="c4o665b7dqyb">
        <h2 id="cierre" className="font-display text-3xl uppercase text-navy sm:text-4xl" data-id="element-55" data-mp="83m6jnddjcvt">
          Una última oportunidad
        </h2>
        <p className="mt-1 text-[0.82rem] leading-snug text-negro/75 sm:text-sm" data-id="element-56" data-mp="h5vfi8szuy73">
          Puedes seguir guardando videos sobre routers, WiFi, cableado,
          conectores RJ45, switches y diagnóstico sin saber qué deberías
          aprender primero. O puedes comenzar hoy a construir una nueva
          habilidad siguiendo una ruta organizada desde cero.
        </p>
        <p className="mt-1 text-sm font-bold text-navy sm:text-base" data-id="element-57" data-mp="14vppmilxi8nn">
          No necesitas ser experto en redes para empezar.{' '}
          <span className="bg-amarillo px-1 font-extrabold" data-id="element-58" data-mp="2c4wmyl7pu6ft">Necesitas dar el primer paso.</span>
        </p>

        <div className="mt-3 rounded-2xl border-2 border-navy bg-white p-3.5" data-id="element-59" data-mp="2h3hruxxwxeal">
          <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mx-auto block max-w-[14rem] overflow-hidden rounded-xl transition-transform duration-150 ease-soft active:scale-[0.99]" data-id="element-60" data-mp="2m2ua15du9x6u">
            <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-61" data-mp="2v2r3dkb6bk88" />
          </a>
          <p className="mt-2 text-[0.82rem] font-extrabold text-wifi sm:text-sm" data-id="element-62" data-mp="301k9uss1mayw">📡 {PRODUCT_NAME}</p>
          <p className="text-sm font-bold text-navy" data-id="element-63" data-mp="34un4734n9og5">6 Tomos + 5 Bonos</p>
          <p className="mt-0.5 text-sm text-negro/70" data-id="element-64" data-mp="39syc38bdpovq">
            Valor de los bonos: <span className="text-red-600 line-through" data-id="element-65" data-mp="3eri2bkx09mtw">{BONUS_TOTAL}</span>
          </p>
          <p className="font-display text-4xl uppercase leading-tight text-navy sm:text-5xl" data-id="element-66" data-mp="3epotq02u0sj9">
            Hoy: <span className="bg-amarillo px-1.5" data-id="element-67" data-mp="3iqqskfsu72kp">{PRICE}</span>
          </p>
          <CtaBlock note="Acceso Inmediato • Entrega Digital • Garantía de 7 Días" data-id="element-68" data-mp="1jolcga9k4d9u" />
        </div>
      </div>
    </section>;
}